import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/index';
import { HttpClient } from '@angular/common/http';
import { TimezoneService } from '../services/timezone.service';
import { CoreTargetService } from '../core/services/target.service';
import { LocalStorageService } from '../core/services/local-storage.service';
import { USE_BUGS_BASE } from '../core/http/http-context.tokens';
import { HttpContext } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class DiagnosticsService {
  constructor(
    private _http: HttpClient,
    private timezoneService: TimezoneService,
    private targetService: CoreTargetService,
    private localStorageService: LocalStorageService,
  ) {}

  isMasterDashboard() {
    const role = this.localStorageService.get('role');
    if (
      role == 'master' ||
      role == 'schulte' ||
      role == 'ochsnersport' ||
      this.localStorageService.get('master')
    ) {
      return true;
    }
    return false;
  }

  behamicsSample: boolean = false;
  getTargetFromLocalStorage() {
    let target = this.targetService.getSelectedTarget('target');

    if (target == 'behamicsSample') {
      target = 'gonser';
      this.behamicsSample = true;
    } else {
      this.behamicsSample = false;
    }

    return target;
  }

  getInfoBugData(data: any): Observable<any> {
    let target: any = this.getTargetFromLocalStorage();

    let params = `target=${target}&startDate=${data.startDate}&endDate=${data.endDate}&rate=${data.rate}`;

    if (this.behamicsSample) {
      params += '&behamicsSample=true';
    }

    return this._http.get(`/bugs/?${params}`);
  }

  bugDetails(data: any): Observable<any> {
    let target: any = this.getTargetFromLocalStorage();

    let params = '';

    if (data?.endDate) {
      params = `target=${target}&startDate=${data.startDate}&endDate=${data.endDate}&rate=${data.rate}`;

      if (this.behamicsSample) {
        params += '&behamicsSample=true';
      }

      return this._http.get(`/bugs/bugDetails?${params}`);
    } else {
      params = `target=${target}&startDate=${data.startDate}&rate=${data.rate}`;

      if (this.behamicsSample) {
        params += '&behamicsSample=true';
      }

      return this._http.get(`/bugs/bugDetails?${params}`);
    }
  }

  getTimeRangeBugData(data: any): Observable<any> {
    let target: any = this.getTargetFromLocalStorage();

    let params = '';
    if (data.page && data.page != 'Show_All') {
      params = '&page=' + data.page;
    }
    if (data.category && data.category != 'Show_All') {
      params = params + '&bug_category=' + data.category;
    }
    if (data.origin && data.origin != 'Show All') {
      params = params + '&origin=' + data.origin;
    }
    if (
      data.device &&
      data.device != 'overall' &&
      ['desktop', 'mobile', 'tablet'].includes(data.device)
    ) {
      params += '&device=' + data.device;
    }

    if (this.behamicsSample) {
      params += '&behamicsSample=true';
    }
    if (data.archivedOnly) {
      params += '&archivedOnly=true';
    }

    return this._http.get(
      `/bugs/revenue-loss/?target=${target}&startDate=${data.startDate}&endDate=${data.endDate}&rate=day` +
        params,
    );
    // return this._http.get(
    //   `/bugs/revenue-loss/?target=${target}&startDate=${data.startDate}&endDate=${data.endDate}&rate=${data.rate}` +
    //     params
    // );
  }

  getBugFrequency(data: any): Observable<any> {
    let target: any = this.getTargetFromLocalStorage();

    let params = `target=${target}&startDate=${data.startDate}&endDate=${data.endDate}&rate=${data.rate}&bug=${data.bugName}`;
    if (this.behamicsSample) {
      params += '&behamicsSample=true';
    }

    return this._http.get(`/bugs/bug-frequency/?${params}`);
  }

  getTotalBugFrequency(data: any): Observable<any> {
    let target: any = this.getTargetFromLocalStorage();

    let params = `target=${target}&startDate=${data.startDate}&endDate=${data.endDate}&rate=${data.rate}`;
    if (this.behamicsSample) {
      params += '&behamicsSample=true';
    }

    return this._http.get(`/bugs/total-errors?${params}`);
  }

  getRPVImpact(data: any): Observable<any> {
    let target: any = this.getTargetFromLocalStorage();

    let params = `target=${target}&startDate=${data.startDate}&endDate=${data.endDate}&rate=${data.rate}`;
    if (this.behamicsSample) {
      params += '&behamicsSample=true';
    }
    return this._http.get(`/bugs/getRPVImpact/?${params}`);
  }

  generateShareLink(data: any): Observable<any> {
    data['target'] = this.getTargetFromLocalStorage();

    let params = '';
    if (data.target) {
      params = `target=${data.target}&bug=${data.name}&rate=${data.rate}&startDate=${data.startDate}&endDate=${data.endDate}`;
    } else {
      params = `bug=${data.name}&rate=${data.rate}&startDate=${data.startDate}&endDate=${data.endDate}`;
    }

    if (this.behamicsSample) {
      params += '&behamicsSample=true';
    }

    return this._http.post('/bugs/links?' + params, {});
  }

  getDailyImpacts(data: any): Observable<any> {
    let target: any = this.getTargetFromLocalStorage();

    let params = `target=${target}&startDate=${data.startDate}&endDate=${data.endDate}&rate=day`;
    if (this.behamicsSample) {
      params += '&behamicsSample=true';
    }

    return this._http.get(`/bugs/headlines?${params}`);
  }

  getDailyCriticalEvents(data: any): Observable<any> {
    let target: any = this.getTargetFromLocalStorage();

    let params = `target=${target}&startDate=${data.startDate}&endDate=${data.endDate}`;
    if (this.behamicsSample) {
      params += '&behamicsSample=true';
    }

    return this._http.get(`/bugs/critical_events?${params}`);
  }

  getRelativeValues(data: any): Observable<any> {
    let target: any = this.getTargetFromLocalStorage();

    let params = `target=${target}&startDate=${data.startDate}&endDate=${data.endDate}&variable=${data.variable}`;
    if (this.behamicsSample) {
      params += '&behamicsSample=true';
    }
    return this._http.get(`/bugs/relative_values?${params}`);
  }

  getBehavioralVariables(data: any): Observable<any> {
    let target: any = this.getTargetFromLocalStorage();

    let tmpParams = '';

    if (data?.rate == 'hourly' && data?.date) {
      tmpParams = `target=${target}&startDate=${data.startDate}&endDate=${data.endDate}&rate=hourly&date=${data.date}`;
    } else {
      tmpParams = `target=${target}&startDate=${data.startDate}&endDate=${data.endDate}`;
    }

    if (this.behamicsSample) {
      tmpParams += '&behamicsSample=true';
    }

    return this._http.get(`/bugs/behavioral_variables?${tmpParams}`);
  }

  getHistogramData(): Observable<any> {
    let target: any = this.getTargetFromLocalStorage();

    let params = `target=${target}`;
    if (this.behamicsSample) {
      params += '&behamicsSample=true';
    }

    return this._http.get(`/bugs/histogram?${params}`);
  }

  predictVariables(data: any): Observable<any> {
    return this._http.post(`/predict_behavioral`, data);
  }

  getErrorVisits(data: any): Observable<any> {
    if (data['target']) {
      data['target'] = this.getTargetFromLocalStorage();
    }

    if (this.behamicsSample) {
      data['behamicsSample'] = 'true';
    }

    return this._http.post(`/diagnostics/getErrorVisits`, data, {
      context: new HttpContext().set(USE_BUGS_BASE, true),
    });
  }

  getVisitDetails(data: any): Observable<any> {
    if (this.targetService.getSelectedTarget('target') == 'behamicsSample') {
      data['target'] = 'gonser';
      data['behamicsSample'] = 'true';
    }

    return this._http.post(`/diagnostics/getVisitDetails`, data, {
      context: new HttpContext().set(USE_BUGS_BASE, true),
    });
  }

  getBugDetails(data: any): Observable<any> {
    if (this.targetService.getSelectedTarget('target') == 'behamicsSample') {
      data['target'] = 'gonser';
      data['behamicsSample'] = 'true';
    }
    return this._http.post(`/diagnostics/getBugDetails`, data, {
      context: new HttpContext().set(USE_BUGS_BASE, true),
    });
  }

  getDailyRevenueLoss(): Observable<any> {
    let target: any = this.getTargetFromLocalStorage();

    let params = `target=${target}`;
    if (this.behamicsSample) {
      params += '&behamicsSample=true';
    }

    if (params.includes('rate')) {
      params.replace('rate=hourly', 'rate=day');
    }

    return this._http.get(`/bugs/daily-revenue-loss/?${params}`);
  }

  getSimulationLineChart(data: any): Observable<any> {
    if (this.targetService.getSelectedTarget('target') === 'behamicsSample') {
      data['target'] = 'gonser';
      data['behamicsSample'] = 'true';
    }
    return this._http.post(`/simulations`, data, {
      context: new HttpContext().set(USE_BUGS_BASE, true),
    });
  }

  getGoLiveTargets(): Observable<any> {
    let timezone = this.timezoneService.getTimezone();
    return this._http.get(`/go-live/targets?timezone=${timezone}`, {
      context: new HttpContext().set(USE_BUGS_BASE, true),
    });
  }

  deleteGoLiveTarget(target: string): Observable<any> {
    return this._http.delete(`/go-live/target?target=${target}`, {
      context: new HttpContext().set(USE_BUGS_BASE, true),
    });
  }

  getAvailableTargets(): Observable<any> {
    return this._http.get(`/go-live/availableTargets`, {
      context: new HttpContext().set(USE_BUGS_BASE, true),
    });
  }

  newGoLiveTargets(target: string): Observable<any> {
    return this._http.post(
      `/go-live/newTarget`,
      { target: target },
      {
        context: new HttpContext().set(USE_BUGS_BASE, true),
      },
    );
  }

  getAIGeneratedMessage(bug: string, target: string): Observable<any> {
    let params = `bug=${bug}&target=${target}`;
    if (this.behamicsSample) {
      params += `&behamicsSample=true`;
    }

    return this._http.get(`/diagnostics/getAIGeneratedMessage?${params}`, {
      context: new HttpContext().set(USE_BUGS_BASE, true),
    });
  }
  getAIGeneratedMessageIssueType(data: any): Observable<any> {
    if (this.targetService.getSelectedTarget('target') === 'behamicsSample') {
      data['target'] = 'gonser';
      data['behamicsSample'] = 'true';
    }

    return this._http.post(`/diagnostics/getAIGeneratedIssueType`, data, {
      context: new HttpContext().set(USE_BUGS_BASE, true),
    });
  }
  getBrowserOSImpact(params: string): Observable<any> {
    if (params.includes('behamicsSample')) {
      params = params.replace('behamicsSample', 'gonser');
      params += '&behamicsSample=true';
    }
    return this._http.get(`/diagnostics/getBrowserOSImpact?${params}`, {
      context: new HttpContext().set(USE_BUGS_BASE, true),
    });
  }
  archiveBug(data: any, target: string): Observable<any> {
    return this._http.post(`/bugs/archiveBug?target=${target}`, data);
  }
  archiveAllBugs(
    target: string,
    startDate: string,
    endDate: string,
  ): Observable<any> {
    return this._http.post(
      `/bugs/archiveAllBugs?target=${target}&startDate=${startDate}&endDate=${endDate}`,
      {},
    );
  }
  unArchiveAllBugs(target: string): Observable<any> {
    return this._http.post(`/bugs/unArchiveAllBugs?target=${target}`, {});
  }
  unArchiveBug(data: any, target: string): Observable<any> {
    return this._http.post(`/bugs/unArchiveBug?target=${target}`, data);
  }
  getArchivedBugs(target: string): Observable<any> {
    return this._http.get(`/bugs/getArchivedBugs?target=${target}`);
  }
  getAllArchivedBugs(target: string): Observable<any> {
    return this._http.get(`/bugs/getAllArchivedBugs?target=${target}`);
  }
}
